// The permission reminder is only part of the iOS and Android Work composer.
export default function WorkNotificationNotice() { return null; }
